module.exports = __webpack_public_path__ + "h5/img/logo2.ebcd2677.png";